// import { useContext, useEffect, useState } from 'react';
// import './GuestList.css';
// import { Link, useLocation, useParams } from 'react-router-dom';
// import axios from 'axios';
// import { AuthContext } from '../context';
// import { Payment } from '../payment';
// import { toast } from 'react-toastify';


// export const GuestList = () => {
//   let { total } = useParams();
//   const context = useContext(AuthContext);
//   const logout = context?.logout;
//   const paymentHistory = context?.paymentHistory;
//   const location = useLocation();
//   const invitationId = location?.state?.invitationId;
//   // const userData = context?.storeUserData;
//   const id = localStorage.getItem('_id');
//   const totalAmountPerBox = total;
//   const [userId, setUserId] = useState(id);
//   const token = context?.token || localStorage.getItem("token")
//   const [guestList, setGuestList] = useState([]);
//   const [checkedItems, setCheckedItems] = useState([])
//   const [boxes, setBoxes] = useState([])
//   const [totalbox, setTotalBox] = useState();
//   const [totalGuest, setTotalGuest] = useState()
//   const [userBox, setUserBox] = useState(1);
//   const [isUserAddressChecked, setIsUserAddressChecked] = useState(false);
//   const [totalPrice, setTotalPrice] = useState();
//   const [searchText, setSearchText] = useState();
//   const [openRazorpay, setOpenRazorPay] = useState(false)
//   const [guest, setGuest] = useState([])
//   const [userData, setUserData] = useState({})
//   const [localInputs, setLocalInputs] = useState({});

//   const [isDeliverycharge, setIsDeliverycharge] = useState();

//   const getGuestList = async () => {
//     await axios.get(`${process.env.REACT_APP_BASE_URL}api/user/guest-list/${userId}`, {
//       headers: {
//         Authorization: `Bearer ${token}`
//       },

//     }).then((res) => {
//       setGuestList(res?.data?.guestList)
//       console.log(res?.data?.guestList, '555888877777')
//     }).catch((error) => {
//       if (error?.response?.data?.Message === 'jwt expired') {
//         logout()
//       }
//       console.log(error)
//     })
//   };


//   const getUserData = async () => {
//     await axios.get(`${process.env.REACT_APP_BASE_URL}api/user/data/${userId}`, {
//       headers: {
//         Authorization: `Bearer ${token}`
//       },
//     }).then((res) => {
//       setUserData(res?.data?.userData)
//     }).catch((error) => {
//       if (error?.response?.data?.Message === 'jwt expired') {
//         logout()
//       }
//       console.log(error)
//     })
//   };




//   useEffect(() => {
//     getGuestList()
//   }, [searchText, userId])

//   useEffect(() => {
//     getUserData()
//   }, [userId, searchText])

//   const countFun = () => {
//     // const countBox = checkedItems?.reduce((ele1, ele2) => ele1 + Number(ele2?.quantity), 0);
//     const countBox = checkedItems?.reduce(
//       (ele1, ele2) => ele1 + (Number(ele2?.quantity) || 0),
//       0
//     );

//     const countGuest = checkedItems?.length;
//     let total = countBox;
//     let price = totalAmountPerBox * countBox;

//     if (isDeliverycharge) {
//       console.log(isDeliverycharge, "ghggggg")
//       price = price + 49 * countBox;
//     }
//     if (isUserAddressChecked && userBox) {
//       total += Number(userBox);
//       price += Number(totalAmountPerBox * userBox);
//       if (isDeliverycharge) {
//         price = price + Number(20 * userBox)
//       }

//     }
//     setTotalBox(total);
//     setTotalGuest(countGuest);
//     setTotalPrice(price)
//   };


//   useEffect(() => {
//     console.log("2222222222222")
//     countFun();
//   }, [checkedItems, boxes, isUserAddressChecked, userBox]);

//   useEffect(() => {

//     const updatedGuest = checkedItems.map((item) => {
//       const box = boxes.find((b) => b.idx === item.idx);
//       const quantity = box?.quantity || 1;

//       const existing = guest.find((g) => g.idx == item.idx);
//       return {
//         idx: item.idx,
//         guestId: existing?.guestId || '',
//         quantity,
//         name: existing?.name || '',
//         address: existing?.address || '',
//         pincode: existing?.pincode || '',
//         mobile: existing?.mobile || ''
//       };
//     });
//     const userGuest = guest.find((g) => g.guestId === userId);
//     if (userGuest) {
//       setGuest([...updatedGuest, userGuest]);
//     } else {
//       setGuest(updatedGuest);
//     }
//     // setGuest(updatedGuest);
//   }, [boxes, checkedItems]);


//   const handleChecked = (index, guestData) => {

//     const isExist = checkedItems?.some((ele) => (ele?.idx == index))
//     if (isExist) {
//       setCheckedItems(checkedItems.filter((ele) => (ele?.idx) != index))
//     } else {
//       const checkedData = (boxes.filter((ele) => ele.idx == index))
//       setCheckedItems([...checkedItems, { idx: index, quantity: checkedData[0]?.quantity || 1 }])
//     }
//     const isGuestExist = guest?.some((item) => item.idx === index);
//     if (isGuestExist) {
//       setGuest(guest.filter((item) => item.idx !== index));
//     } else {
//       const checkedBox = boxes.find((ele) => ele.idx === index);
//       const quantity = checkedBox?.quantity || 1;
//       setGuest([...guest, {
//         idx: index, guestId: guestData._id,
//         name: guestData.name,
//         address: guestData.address,
//         quantity,
//         pincode: guestData?.pincode || '',
//         mobile: guestData?.mobile || ''
//       }]);
//     }
//   }


//   const handleBox = (value, index) => {
//     const isExist = boxes.some((ele) => ele.idx == index)

//     const isCheckedExist = checkedItems.some((ele) => ele.idx === index);
//     if (isCheckedExist)
//       setCheckedItems(
//         checkedItems.map((ele) =>
//           // ele.idx === index ? { ...ele, quantity: value } : ele
//           ele.idx == index ? { ...ele, quantity: value || 0 } : ele

//         )
//       );

//     if (isExist) {
//       setBoxes(
//         boxes.map((ele) =>
//           ele.idx == index ? { ...ele, quantity: value } : ele
//         )
//       );
//     } else {
//       setBoxes([...boxes, { idx: index, quantity: value }])
//     }
//   }

//   const handleUser = (boxes) => {
//     setUserBox(boxes);
//   }

//   useEffect(() => {
//     handleCheckUser(isUserAddressChecked)
//   }, [userBox])

//   const handleCheckUser = (isChecked) => {
//     if (isChecked) {
//       setIsUserAddressChecked(true);

//       setGuest((prevGuest) => {
//         const isAlreadyAdded = prevGuest.some((ele) => ele.guestId === userId);
//         if (isAlreadyAdded) {
//           return prevGuest?.map((ele) =>
//             ele.guestId === userId
//               ? { ...ele, quantity: userBox }
//               : ele
//           );
//         } else {
//           return [...prevGuest, { guestId: userId, quantity: userBox, idx: userId, name: userData?.name, address: userData?.address, pincode: userData?.pincode, mobile: userData?.mobile }];
//         }
//       });
//     }
//     else {
//       setIsUserAddressChecked(false)
//       setGuest(guest?.filter((ele) => ele.guestId != userId) || []);
//     }
//   }

//   console.log(guest, "ddddddd")

//   const handlePayment = () => {
//     if (!paymentHistory?.length) {
//       toast.error("Your data have been lose please Select One more time  !", {
//         position: 'bottom-right'
//       })
//       return
//     }
//     if (!guest?.length) {
//       toast.error("Please select at least one recipient to continue.", {
//         position: 'bottom-right'
//       })
//       return
//     }

//     setOpenRazorPay(false)
//     setTimeout(() => {
//       setOpenRazorPay(true)
//     }, 50);
//   }

//   console.log(guest, 'aaaaaaaaaa+')

//   // const getcontact = async () => {
//   //   await axios.get(
//   //     'https://people.googleapis.com/v1/people/me/connections',
//   //     {
//   //       params: {
//   //         personFields: 'names,emailAddresses,phoneNumbers',
//   //       },
//   //       headers: {
//   //         Authorization: `Bearer ${userData?.token}`,
//   //       },
//   //     }
//   //   ).then((res) => {
//   //     console.log(res.data, '3333333333333')
//   //   }).catch((err) => {
//   //     console.log(err)
//   //   })
//   // }

//   return (
//     <div className="guest-list-container">
//       <div className="guest-list-header">
//         {/* <input
//           type="search"
//           placeholder="Search..."
//           className="search-input"
//           value={searchText}
//           onChange={(e) => setSearchText(e.target.value)}
//         /> */}
//         {/* <button onClick={getcontact}>import contact</button> */}
//         {/* <Link to='/guest' className="add-guest-button">+ add Guest</Link> */}
//       </div>
//       <div className="table-wrapper">
//         <table>
//           <thead>
//             <tr>
//               <th className='guest-hash'>'#'</th>
//               <th className='guest-no'>No.</th>
//               <th className='guest-name'>NAME</th>
//               <th className='guest-address'>ADDRESS</th>
//               <th className='number-guest'>GUEST NUMBER</th>
//               <th className='category-guest'>CATEGORIES</th>
//               <th className='guest-quantity'>Boxes quantity</th>
//             </tr>
//           </thead>
//           <tbody>
//             {guestList?.map((guest, index) => {
//               if (!guest?.address) {
//                 return;
//               }
//               return <tr key={guest._id || index}>
//                 <td className='guest-hash'>
//                   {
//                     guest.address ? <input type="checkbox" onChange={() => { handleChecked(index, guest) }} /> :
//                       <input type="checkbox" disabled />
//                   }
//                   {/* <input type="checkbox" onChange={() => { handleChecked(index, guest) }} /> */}
//                 </td>
//                 <td className='guest-no'>{index + 1}</td>
//                 <td className='guest-name'>{guest.name}</td>
//                 <td className='guest-address'>{!guest.address ? (
//                   <button className="sent-request-button">Sent Request</button>
//                 ) : (guest?.address)}</td>
//                 <td className='number-guest'>
//                   {guest.guestNo}
//                 </td>
//                 <td className='category-guest'>{guest.category}</td>
//                 <td className='guest-quantity'>
//                   <input type='text' className='invite-guest-list'
//                     //  value={boxes.find((ele) => ele.idx === index)?.quantity || 1}
//                     //   onChange={(e) => {
//                     //   const isNumber = e.target.value;
//                     //   if (/^\d*$/.test(isNumber)) {
//                     //     handleBox(isNumber, index)
//                     //   }
//                     // }} 
//                     value={
//                       localInputs[index] !== undefined
//                         ? localInputs[index]
//                         : boxes.find((ele) => ele.idx === index)?.quantity ?? ""
//                     }
//                     onChange={(e) => {
//                       const value = e.target.value;
//                       setLocalInputs(prev => ({ ...prev, [index]: value }));
//                       // if (/^\d*$/.test(value)) {
//                       //   handleBox(value, index);
//                       // }
//                       if (/^\d*$/.test(value)) {
//                         handleBox(value === "" ? 0 : Number(value), index);
//                       }

//                     }}
//                   />
//                 </td>
//               </tr >
//             })}
//           </tbody>
//         </table>
//       </div>

//       {isDeliverycharge && <div className="shipping-info">
//         <div>Extra Shipping Charges ₹49 per box</div>
//       </div>}

//       <div className="my-address-section">
//         <div className="my-address-row">
//           <div>
//             {userData?.address ?
//               <input type="checkbox" checked={isUserAddressChecked} onChange={(e) => handleCheckUser(e.target.checked)} />
//               :
//               <input type="checkbox" disabled />
//             }
//           </div>
//           <div>My Address</div>
//           {userData?.address && <div>{userData?.address}</div>}

//         </div>
//         <div>
//           <input type='text' className='my-address-text' value={userBox} onChange={(e) => {
//             const isNumber = e.target.value;
//             // if (/^\d+$/.test(isNumber)) {
//             //   handleUser(isNumber)
//             // }
//             if (/^\d*$/.test(isNumber)) {
//               handleUser(isNumber === "" ? 0 : Number(isNumber))
//             }

//           }} />

//         </div>
//       </div>
//       {isDeliverycharge &&
//         <div className="shipping-info">
//           <div>Extra Shipping Charges ₹20 per box</div>
//         </div>
//       }

//       <div className="totals-bar">
//         <span>Total Guest:{totalGuest} </span>
//         <span>Total Boxes:{totalbox} </span>
//       </div>
//       <div className="pay-button-container">
//         <button className="pay-button" onClick={handlePayment}>Pay</button>
//       </div>
//       <div className="pay-button-container">
//         Total Price:{totalPrice} /-
//       </div>
//       {openRazorpay && <  Payment amount={totalPrice} guest={guest} userId={userId} />}
//     </div>
//   );
// }

// // import { useContext, useEffect, useState } from 'react';
// // import './GuestList.css';
// // import { Link, useLocation, useParams } from 'react-router-dom';
// // import axios from 'axios';
// // import { AuthContext } from '../context';
// // import { Payment } from '../payment';
// // import { toast } from 'react-toastify';

// // export const GuestList = () => {
// //   let { total } = useParams();
// //   const context = useContext(AuthContext);
// //   const logout = context?.logout;
// //   const paymentHistory = context?.paymentHistory;
// //   const location = useLocation();
// //   const invitationId = location?.state?.invitationId;
// //   const id = localStorage.getItem('_id');
// //   const totalAmountPerBox = total;
// //   const [userId, setUserId] = useState(id);
// //   const token = context?.token || localStorage.getItem("token")
// //   const [guestList, setGuestList] = useState([]);
// //   const [checkedItems, setCheckedItems] = useState([])
// //   const [boxes, setBoxes] = useState([])
// //   const [totalbox, setTotalBox] = useState(0);
// //   const [totalGuest, setTotalGuest] = useState(0)
// //   const [userBox, setUserBox] = useState(0);
// //   const [isUserAddressChecked, setIsUserAddressChecked] = useState(false);
// //   const [totalPrice, setTotalPrice] = useState(0);
// //   const [searchText, setSearchText] = useState();
// //   const [openRazorpay, setOpenRazorPay] = useState(false)
// //   const [guest, setGuest] = useState([])
// //   const [userData, setUserData] = useState({})
// //   const [localInputs, setLocalInputs] = useState({});
// //   const [isDeliverycharge, setIsDeliverycharge] = useState();

// //   const getGuestList = async () => {
// //     await axios.get(`${process.env.REACT_APP_BASE_URL}api/user/guest-list/${userId}`, {
// //       headers: { Authorization: `Bearer ${token}` },
// //       params: { q: searchText }
// //     }).then((res) => {
// //       setGuestList(res?.data?.guestList)
// //     }).catch((error) => {
// //       if (error?.response?.data?.Message === 'jwt expired') logout()
// //     })
// //   };

// //   const getUserData = async () => {
// //     await axios.get(`${process.env.REACT_APP_BASE_URL}api/user/data/${userId}`, {
// //       headers: { Authorization: `Bearer ${token}` },
// //     }).then((res) => {
// //       setUserData(res?.data?.userData)
// //     }).catch((error) => {
// //       if (error?.response?.data?.Message === 'jwt expired') logout()
// //     })
// //   };

// //   useEffect(() => {
// //     axios.get(`${process.env.REACT_APP_BASE_URL}api/user/invitation/${invitationId}`).then((res) => {
// //       setIsDeliverycharge(res?.data?.invitation?.isDeliveryCharge);
// //     }).catch(() => {})
// //   }, [])

// //   useEffect(() => { getGuestList() }, [searchText, userId])
// //   useEffect(() => { getUserData() }, [userId, searchText])

// //   const countFun = () => {
// //     const countBox = checkedItems?.reduce(
// //       (ele1, ele2) => ele1 + (Number(ele2?.quantity) || 0),
// //       0
// //     );
// //     const countGuest = checkedItems?.length;
// //     let total = countBox;
// //     let price = totalAmountPerBox * countBox;

// //     if (isDeliverycharge) {
// //       price = price + 49 * countBox;
// //     }
// //     if (isUserAddressChecked && userBox) {
// //       total += Number(userBox) || 0;
// //       price += totalAmountPerBox * (Number(userBox) || 0);
// //       if (isDeliverycharge) {
// //         price = price + 20 * (Number(userBox) || 0);
// //       }
// //     }
// //     setTotalBox(total);
// //     setTotalGuest(countGuest);
// //     setTotalPrice(price);
// //   };

// //   useEffect(() => { countFun(); }, [checkedItems, boxes, isUserAddressChecked, userBox]);

// //   const handleChecked = (index, guestData) => {
// //     const isExist = checkedItems?.some((ele) => (ele?.idx == index))
// //     if (isExist) {
// //       setCheckedItems(checkedItems.filter((ele) => (ele?.idx) != index))
// //     } else {
// //       const checkedData = (boxes.filter((ele) => ele.idx == index))
// //       setCheckedItems([...checkedItems, { idx: index, quantity: checkedData[0]?.quantity || 0 }])
// //     }
// //   }

// //   const handleBox = (value, index) => {
// //     const isExist = boxes.some((ele) => ele.idx == index)
// //     const isCheckedExist = checkedItems.some((ele) => ele.idx === index);

// //     if (isCheckedExist)
// //       setCheckedItems(
// //         checkedItems.map((ele) =>
// //           ele.idx === index ? { ...ele, quantity: value || 0 } : ele
// //         )
// //       );

// //     if (isExist) {
// //       setBoxes(
// //         boxes.map((ele) =>
// //           ele.idx == index ? { ...ele, quantity: value || 0 } : ele
// //         )
// //       );
// //     } else {
// //       setBoxes([...boxes, { idx: index, quantity: value || 0 }])
// //     }
// //   }

// //   const handleUser = (boxes) => { setUserBox(boxes); }

// //   const handleCheckUser = (isChecked) => {
// //     if (isChecked) {
// //       setIsUserAddressChecked(true);
// //       setGuest((prevGuest) => {
// //         const isAlreadyAdded = prevGuest.some((ele) => ele.guestId === userId);
// //         if (isAlreadyAdded) {
// //           return prevGuest?.map((ele) =>
// //             ele.guestId === userId ? { ...ele, quantity: userBox } : ele
// //           );
// //         } else {
// //           return [...prevGuest, {
// //             guestId: userId, quantity: userBox, idx: userId,
// //             name: userData?.name, address: userData?.address,
// //             pincode: userData?.pincode, mobile: userData?.mobile
// //           }];
// //         }
// //       });
// //     } else {
// //       setIsUserAddressChecked(false)
// //       setGuest(guest?.filter((ele) => ele.guestId != userId) || []);
// //     }
// //   }

// //   const handlePayment = () => {
// //     if (!paymentHistory?.length) {
// //       toast.error("Your data have been lost please Select One more time  !", { position: 'bottom-right' })
// //       return
// //     }
// //     if (!guest?.length) {
// //       toast.error("Please select at least one recipient to continue.", { position: 'bottom-right' })
// //       return
// //     }
// //     setOpenRazorPay(false)
// //     setTimeout(() => { setOpenRazorPay(true) }, 50);
// //   }

// //   return (
// //     <div className="guest-list-container">
// //       <div className="guest-list-header">
// //         <input
// //           type="search"
// //           placeholder="Search..."
// //           className="search-input"
// //           value={searchText}
// //           onChange={(e) => setSearchText(e.target.value)}
// //         />
// //       </div>
// //       <div className="table-wrapper">
// //         <table>
// //           <thead>
// //             <tr>
// //               <th className='guest-hash'>'#'</th>
// //               <th className='guest-no'>No.</th>
// //               <th className='guest-name'>NAME</th>
// //               <th className='guest-address'>ADDRESS</th>
// //               <th className='number-guest'>GUEST NUMBER</th>
// //               <th className='category-guest'>CATEGORIES</th>
// //               <th className='guest-quantity'>Boxes quantity</th>
// //             </tr>
// //           </thead>
// //           <tbody>
// //             {guestList?.map((guest, index) => {
// //               if (!guest?.address) return null;
// //               return <tr key={guest._id || index}>
// //                 <td className='guest-hash'>
// //                   {guest.address
// //                     ? <input type="checkbox" onChange={() => { handleChecked(index, guest) }} />
// //                     : <input type="checkbox" disabled />}
// //                 </td>
// //                 <td className='guest-no'>{index + 1}</td>
// //                 <td className='guest-name'>{guest.name}</td>
// //                 <td className='guest-address'>{guest?.address}</td>
// //                 <td className='number-guest'>{guest.guestNo}</td>
// //                 <td className='category-guest'>{guest.category}</td>
// //                 <td className='guest-quantity'>
// //                   <input
// //                     type='text'
// //                     className='invite-guest-list'
// //                     value={
// //                       localInputs[index] !== undefined
// //                         ? localInputs[index]
// //                         : boxes.find((ele) => ele.idx === index)?.quantity ?? ""
// //                     }
// //                     onChange={(e) => {
// //                       const value = e.target.value;
// //                       setLocalInputs((prev) => ({ ...prev, [index]: value }));
// //                       if (/^\d*$/.test(value)) {
// //                         handleBox(value === "" ? 0 : Number(value), index);
// //                       }
// //                     }}
// //                   />
// //                 </td>
// //               </tr >
// //             })}
// //           </tbody>
// //         </table>
// //       </div>

// //       {isDeliverycharge && <div className="shipping-info">
// //         <div>Extra Shipping Charges ₹49 per box</div>
// //       </div>}

// //       <div className="my-address-section">
// //         <div className="my-address-row">
// //           <div>
// //             {userData?.address ?
// //               <input type="checkbox" checked={isUserAddressChecked} onChange={(e) => handleCheckUser(e.target.checked)} />
// //               : <input type="checkbox" disabled />
// //             }
// //           </div>
// //           <div>My Address</div>
// //           {userData?.address && <div>{userData?.address}</div>}
// //         </div>
// //         <div>
// //           <input
// //             type='text'
// //             className='my-address-text'
// //             value={userBox}
// //             onChange={(e) => {
// //               const isNumber = e.target.value;
// //               if (/^\d*$/.test(isNumber)) {
// //                 handleUser(isNumber === "" ? 0 : Number(isNumber))
// //               }
// //             }}
// //           />
// //         </div>
// //       </div>

// //       {isDeliverycharge &&
// //         <div className="shipping-info">
// //           <div>Extra Shipping Charges ₹20 per box</div>
// //         </div>
// //       }

// //       <div className="totals-bar">
// //         <span>Total Guest:{totalGuest} </span>
// //         <span>Total Boxes:{totalbox} </span>
// //       </div>
// //       <div className="pay-button-container">
// //         <button className="pay-button" onClick={handlePayment}>Pay</button>
// //       </div>
// //       <div className="pay-button-container">
// //         Total Price:{totalPrice} /-
// //       </div>
// //       {openRazorpay && <Payment amount={totalPrice} guest={guest} userId={userId} />}
// //     </div>
// //   );
// // }


// import { useContext, useEffect, useState } from 'react';
// import './GuestList.css';
// import { Link, useLocation, useParams } from 'react-router-dom';
// import axios from 'axios';
// import { AuthContext } from '../context';
// import { Payment } from '../payment';
// import { toast } from 'react-toastify';


// export const GuestList = () => {
//   let { total } = useParams();
//   const context = useContext(AuthContext);
//   const logout = context?.logout;
//   const paymentHistory = context?.paymentHistory;
//   const location = useLocation();
//   const invitationId = location?.state?.invitationId;
//   // const userData = context?.storeUserData;
//   const id = localStorage.getItem('_id');
//   const totalAmountPerBox = total;
//   const [userId, setUserId] = useState(id);
//   const token = context?.token || localStorage.getItem("token")
//   const [guestList, setGuestList] = useState([]);
//   const [checkedItems, setCheckedItems] = useState([])
//   const [boxes, setBoxes] = useState([])
//   const [totalbox, setTotalBox] = useState();
//   const [totalGuest, setTotalGuest] = useState()
//   // FIX 2: Initialize userBox with an empty string instead of 1
//   const [userBox, setUserBox] = useState("");
//   const [isUserAddressChecked, setIsUserAddressChecked] = useState(false);
//   const [totalPrice, setTotalPrice] = useState();
//   const [searchText, setSearchText] = useState();
//   const [openRazorpay, setOpenRazorPay] = useState(false)
//   const [guest, setGuest] = useState([])
//   const [userData, setUserData] = useState({})
//   // FIX 1: Removed the unnecessary localInputs state

//   const [isDeliverycharge, setIsDeliverycharge] = useState();

//   const getGuestList = async () => {
//     await axios.get(`${process.env.REACT_APP_BASE_URL}api/user/guest-list/${userId}`, {
//       headers: {
//         Authorization: `Bearer ${token}`
//       },

//     }).then((res) => {
//       setGuestList(res?.data?.guestList)
//       console.log(res?.data?.guestList, '555888877777')
//     }).catch((error) => {
//       if (error?.response?.data?.Message === 'jwt expired') {
//         logout()
//       }
//       console.log(error)
//     })
//   };


//   const getUserData = async () => {
//     await axios.get(`${process.env.REACT_APP_BASE_URL}api/user/data/${userId}`, {
//       headers: {
//         Authorization: `Bearer ${token}`
//       },
//     }).then((res) => {
//       setUserData(res?.data?.userData)
//     }).catch((error) => {
//       if (error?.response?.data?.Message === 'jwt expired') {
//         logout()
//       }
//       console.log(error)
//     })
//   };




//   useEffect(() => {
//     getGuestList()
//   }, [searchText, userId])

//   useEffect(() => {
//     getUserData()
//   }, [userId, searchText])

//   const countFun = () => {
//     // const countBox = checkedItems?.reduce((ele1, ele2) => ele1 + Number(ele2?.quantity), 0);
//     const countBox = checkedItems?.reduce(
//       (ele1, ele2) => ele1 + (Number(ele2?.quantity) || 0),
//       0
//     );

//     const countGuest = checkedItems?.length;
//     let total = countBox;
//     let price = totalAmountPerBox * countBox;

//     if (isDeliverycharge) {
//       console.log(isDeliverycharge, "ghggggg")
//       price = price + 49 * countBox;
//     }
//     if (isUserAddressChecked && userBox) {
//       total += Number(userBox);
//       price += Number(totalAmountPerBox * userBox);
//       if (isDeliverycharge) {
//         price = price + Number(20 * userBox)
//       }

//     }
//     setTotalBox(total);
//     setTotalGuest(countGuest);
//     setTotalPrice(price)
//   };


//   useEffect(() => {
//     console.log("2222222222222")
//     countFun();
//   }, [checkedItems, boxes, isUserAddressChecked, userBox]);

//   useEffect(() => {

//     const updatedGuest = checkedItems.map((item) => {
//       const box = boxes.find((b) => b.idx === item.idx);
//       const quantity = box?.quantity || 1;

//       const existing = guest.find((g) => g.idx == item.idx);
//       return {
//         idx: item.idx,
//         guestId: existing?.guestId || '',
//         quantity,
//         name: existing?.name || '',
//         address: existing?.address || '',
//         pincode: existing?.pincode || '',
//         mobile: existing?.mobile || ''
//       };
//     });
//     const userGuest = guest.find((g) => g.guestId === userId);
//     if (userGuest) {
//       setGuest([...updatedGuest, userGuest]);
//     } else {
//       setGuest(updatedGuest);
//     }
//     // setGuest(updatedGuest);
//   }, [boxes, checkedItems]);


//   // FIX 1: Updated handleChecked to set quantity in 'boxes' state for display
// const handleChecked = (index, guestData) => {
//     const isExist = checkedItems?.some((ele) => ele.idx === index);

//     if (isExist) {
//         // 1. checkedItems से हटाएं (यह पहले से सही है)
//         setCheckedItems(checkedItems.filter((ele) => ele.idx !== index));

//         // ---> 2. यह लाइन जोड़ें: boxes स्टेट से भी हटाएं <---
//         setBoxes(boxes.filter((ele) => ele.idx !== index));

//         // 3. guest स्टेट से हटाएं (यह भी पहले से सही है)
//         setGuest(guest.filter((item) => item.idx !== index));

//     } else {
//         // जोड़ने वाला लॉजिक (इसमें कोई बदलाव नहीं)
//         const existingBox = boxes.find((b) => b.idx === index);
//         const quantity = existingBox && existingBox.quantity > 0 ? existingBox.quantity : 1;

//         setCheckedItems([...checkedItems, { idx: index, quantity: quantity }]);

//         const isBoxExist = boxes.some((b) => b.idx === index);
//         if (isBoxExist) {
//             setBoxes(
//                 boxes.map((ele) =>
//                     ele.idx === index ? { ...ele, quantity: quantity } : ele
//                 )
//             );
//         } else {
//             setBoxes([...boxes, { idx: index, quantity: quantity }]);
//         }

//         setGuest([...guest, {
//             idx: index,
//             guestId: guestData._id,
//             name: guestData.name,
//             address: guestData.address,
//             quantity,
//             pincode: guestData?.pincode || '',
//             mobile: guestData?.mobile || ''
//         }]);
//     }
// };

//   const handleBox = (value, index) => {
//     const isExist = boxes.some((ele) => ele.idx == index)

//     const isCheckedExist = checkedItems.some((ele) => ele.idx === index);
//     if (isCheckedExist)
//       setCheckedItems(
//         checkedItems.map((ele) =>
//           // ele.idx === index ? { ...ele, quantity: value } : ele
//           ele.idx == index ? { ...ele, quantity: value || 0 } : ele

//         )
//       );

//     if (isExist) {
//       setBoxes(
//         boxes.map((ele) =>
//           ele.idx == index ? { ...ele, quantity: value } : ele
//         )
//       );
//     } else {
//       setBoxes([...boxes, { idx: index, quantity: value }])
//     }
//   }

//   const handleUser = (boxes) => {
//     setUserBox(boxes);
//   }

//   useEffect(() => {
//     handleCheckUser(isUserAddressChecked)
//   }, [userBox])

//   const handleCheckUser = (isChecked) => {
//     if (isChecked) {
//       setIsUserAddressChecked(true);

//       setGuest((prevGuest) => {
//         const isAlreadyAdded = prevGuest.some((ele) => ele.guestId === userId);
//         if (isAlreadyAdded) {
//           return prevGuest?.map((ele) =>
//             ele.guestId === userId
//               ? { ...ele, quantity: userBox }
//               : ele
//           );
//         } else {
//           return [...prevGuest, { guestId: userId, quantity: userBox, idx: userId, name: userData?.name, address: userData?.address, pincode: userData?.pincode, mobile: userData?.mobile }];
//         }
//       });
//     }
//     else {
//       setIsUserAddressChecked(false)
//       setGuest(guest?.filter((ele) => ele.guestId != userId) || []);
//     }
//   }

//   console.log(guest, "ddddddd")

//   const handlePayment = () => {
//     if (!paymentHistory?.length) {
//       toast.error("Your data have been lose please Select One more time  !", {
//         position: 'bottom-right'
//       })
//       return
//     }
//     if (!guest?.length) {
//       toast.error("Please select at least one recipient to continue.", {
//         position: 'bottom-right'
//       })
//       return
//     }

//     setOpenRazorPay(false)
//     setTimeout(() => {
//       setOpenRazorPay(true)
//     }, 50);
//   }

//   console.log(guest, 'aaaaaaaaaa+')

//   return (
//     <div className="guest-list-container">
//       <div className="guest-list-header">
//       </div>
//       <div className="table-wrapper">
//         <table>
//           <thead>
//             <tr>
//               <th className='guest-hash'>'#'</th>
//               <th className='guest-no'>No.</th>
//               <th className='guest-name'>NAME</th>
//               <th className='guest-address'>ADDRESS</th>
//               <th className='number-guest'>GUEST NUMBER</th>
//               <th className='category-guest'>CATEGORIES</th>
//               <th className='guest-quantity'>Boxes quantity</th>
//             </tr>
//           </thead>
//           <tbody>
//             {guestList?.map((guest, index) => {
//               if (!guest?.address) {
//                 return;
//               }
//               return <tr key={guest._id || index}>
//                 <td className='guest-hash'>
//                   {
//                     guest.address ? <input type="checkbox" onChange={() => { handleChecked(index, guest) }} /> :
//                       <input type="checkbox" disabled />
//                   }
//                 </td>
//                 <td className='guest-no'>{index + 1}</td>
//                 <td className='guest-name'>{guest.name}</td>
//                 <td className='guest-address'>{!guest.address ? (
//                   <button className="sent-request-button">Sent Request</button>
//                 ) : (guest?.address)}</td>
//                 <td className='number-guest'>
//                   {guest.guestNo}
//                 </td>
//                 <td className='category-guest'>{guest.category}</td>
//                 <td className='guest-quantity'>
//                   {/* FIX 1: Bind value directly to the 'boxes' state */}
//                   <input
//                     type='text'
//                     className='invite-guest-list'
//                     value={boxes.find((ele) => ele.idx === index)?.quantity || ''}
//                     onChange={(e) => {
//                       const value = e.target.value;
//                       if (/^\d*$/.test(value)) {
//                         handleBox(value === "" ? 0 : Number(value), index);
//                       }
//                     }}
//                   />
//                 </td>
//               </tr >
//             })}
//           </tbody>
//         </table>
//       </div>

//       {isDeliverycharge && <div className="shipping-info">
//         <div>Extra Shipping Charges ₹49 per box</div>
//       </div>}

//       <div className="my-address-section">
//         <div className="my-address-row">
//           <div>
//             {userData?.address ?
//               <input type="checkbox" checked={isUserAddressChecked} onChange={(e) => handleCheckUser(e.target.checked)} />
//               :
//               <input type="checkbox" disabled />
//             }
//           </div>
//           <div>My Address</div>
//           {userData?.address && <div>{userData?.address}</div>}

//         </div>
//         <div>
//           <input type='text' className='my-address-text' value={userBox} onChange={(e) => {
//             const isNumber = e.target.value;
//             if (/^\d*$/.test(isNumber)) {
//               handleUser(isNumber === "" ? 0 : Number(isNumber))
//             }
//           }} />
//         </div>
//       </div>
//       {isDeliverycharge &&
//         <div className="shipping-info">
//           <div>Extra Shipping Charges ₹20 per box</div>
//         </div>
//       }

//       <div className="totals-bar">
//         <span>Total Guest:{totalGuest} </span>
//         <span>Total Boxes:{totalbox} </span>
//       </div>
//       <div className="pay-button-container">
//         <button className="pay-button" onClick={handlePayment}>Pay</button>
//       </div>
//       <div className="pay-button-container">
//         Total Price:{totalPrice} /-
//       </div>
//       {openRazorpay && <Payment amount={totalPrice} guest={guest} userId={userId} />}
//     </div>
//   );
// }
// import { useContext, useEffect, useState } from 'react';
// import './GuestList.css';
// import { Link, useLocation, useParams } from 'react-router-dom';
// import axios from 'axios';
// import { AuthContext } from '../context';
// import { Payment } from '../payment';
// import { toast } from 'react-toastify';

// export const GuestList = () => {
//   let { total } = useParams();
//   const context = useContext(AuthContext);
//   const logout = context?.logout;
//   const paymentHistory = context?.paymentHistory;
//   const location = useLocation();
//   const invitationId = location?.state?.invitationId;
//   const id = localStorage.getItem('_id');
//   const totalAmountPerBox = total;
//   const [userId, setUserId] = useState(id);
//   const token = context?.token || localStorage.getItem("token");
//   const [guestList, setGuestList] = useState([]);

//   // FIX: 'checkedItems' state is no longer needed. 'boxes' is the single source of truth.
//   const [boxes, setBoxes] = useState([]);

//   const [totalbox, setTotalBox] = useState(0);
//   const [totalGuest, setTotalGuest] = useState(0);
//   const [userBox, setUserBox] = useState("");
//   const [isUserAddressChecked, setIsUserAddressChecked] = useState(false);
//   const [totalPrice, setTotalPrice] = useState(0);
//   const [searchText, setSearchText] = useState();
//   const [openRazorpay, setOpenRazorPay] = useState(false);
//   const [guest, setGuest] = useState([]);
//   const [userData, setUserData] = useState({});
//   const [isDeliverycharge, setIsDeliverycharge] = useState();

//   const getGuestList = async () => {
//     await axios.get(`${process.env.REACT_APP_BASE_URL}api/user/guest-list/${userId}`, {
//       headers: { Authorization: `Bearer ${token}` },
//     }).then((res) => {
//       setGuestList(res?.data?.guestList);
//     }).catch((error) => {
//       if (error?.response?.data?.Message === 'jwt expired') logout();
//     });
//   };

//   const getUserData = async () => {
//     await axios.get(`${process.env.REACT_APP_BASE_URL}api/user/data/${userId}`, {
//       headers: { Authorization: `Bearer ${token}` },
//     }).then((res) => {
//       setUserData(res?.data?.userData);
//     }).catch((error) => {
//       if (error?.response?.data?.Message === 'jwt expired') logout();
//     });
//   };

//   useEffect(() => {
//     getGuestList();
//     getUserData();
//   }, [searchText, userId]);

//   // FIX: Rewritten countFun to calculate directly from the 'boxes' state
//   const countFun = () => {
//     // Filter guests who have a quantity greater than 0
//     const itemsWithQuantity = boxes.filter(box => box.quantity > 0);

//     const countBox = itemsWithQuantity.reduce(
//       (total, box) => total + Number(box.quantity), 0
//     );

//     const countGuest = itemsWithQuantity.length;
//     let total = countBox;
//     let price = totalAmountPerBox * countBox;

//     if (isDeliverycharge) {
//       price += 49 * countBox;
//     }
//     if (isUserAddressChecked && userBox > 0) {
//       total += Number(userBox);
//       price += Number(totalAmountPerBox * userBox);
//       if (isDeliverycharge) {
//         price += Number(20 * userBox);
//       }
//     }
//     setTotalBox(total);
//     setTotalGuest(countGuest);
//     setTotalPrice(price);
//   };

//   // FIX: useEffect now depends on 'boxes' state to recalculate total
//   useEffect(() => {
//     countFun();

//     // Also update the final 'guest' list for payment based on 'boxes'
//     const selectedGuests = boxes
//       .filter(box => box.quantity > 0)
//       .map(box => {
//         const guestData = guestList[box.idx];
//         return {
//           idx: box.idx,
//           guestId: guestData._id,
//           name: guestData.name,
//           address: guestData.address,
//           quantity: box.quantity,
//           pincode: guestData?.pincode || '',
//           mobile: guestData?.mobile || ''
//         };
//       });
//     setGuest(selectedGuests);

//   }, [boxes, isUserAddressChecked, userBox]);

//   // FIX: Simplified handleBox. It only needs to update the 'boxes' state.
//   const handleBox = (value, index) => {
//     const quantity = value === "" ? 0 : Number(value);
//     const isExist = boxes.some((ele) => ele.idx === index);

//     let newBoxes;
//     if (isExist) {
//       newBoxes = boxes.map((ele) => ele.idx === index ? { ...ele, quantity } : ele);
//     } else {
//       newBoxes = [...boxes, { idx: index, quantity }];
//     }
//     setBoxes(newBoxes);
//   };

//   // FIX: Rewritten handleChecked. It now works as a shortcut to set quantity to 1 or 0.
//   const handleChecked = (index) => {
//     const existingBox = boxes.find((ele) => ele.idx === index);
//     const isCurrentlyChecked = existingBox && existingBox.quantity > 0;

//     if (isCurrentlyChecked) {
//       // If checked, uncheck it by setting quantity to 0
//       handleBox("0", index);
//     } else {
//       // If unchecked, check it by setting quantity to 1
//       handleBox("1", index);
//     }
//   };

//   const handleUser = (boxes) => {
//     setUserBox(boxes);
//   };

//   const handleCheckUser = (isChecked) => {
//     setIsUserAddressChecked(isChecked);
//   };

//   const handlePayment = () => {
//     if (!paymentHistory?.length) {
//       toast.error("Your data have been lose please Select One more time  !", {
//         position: 'bottom-right'
//       });
//       return;
//     }
//     if (!guest?.length && (!isUserAddressChecked || !userBox > 0)) {
//       toast.error("Please select at least one recipient to continue.", {
//         position: 'bottom-right'
//       });
//       return;
//     }

//     setOpenRazorPay(false);
//     setTimeout(() => {
//       setOpenRazorPay(true);
//     }, 50);
//   };

//   return (
//     <div className="guest-list-container">
//       <div className="guest-list-header"></div>
//       <div className="table-wrapper">
//         <table>
//           <thead>
//             <tr>
//               <th className='guest-hash'>'#'</th>
//               <th className='guest-no'>No.</th>
//               <th className='guest-name'>NAME</th>
//               <th className='guest-address'>ADDRESS</th>
//               <th className='number-guest'>GUEST NUMBER</th>
//               <th className='category-guest'>CATEGORIES</th>
//               <th className='guest-quantity'>Boxes quantity</th>
//             </tr>
//           </thead>
//           <tbody>
//             {guestList?.map((guest, index) => {
//               if (!guest?.address) return null;

//               const currentBox = boxes.find((ele) => ele.idx === index);
//               const quantity = currentBox?.quantity || 0;

//               return <tr key={guest._id || index}>
//                 <td className='guest-hash'>
//                   {guest.address ? (
//                     // FIX: Checkbox is now controlled by the quantity in 'boxes' state
//                     <input
//                       type="checkbox"
//                       checked={quantity > 0}
//                       onChange={() => { handleChecked(index) }}
//                     />
//                   ) : (
//                     <input type="checkbox" disabled />
//                   )}
//                 </td>
//                 <td className='guest-no'>{index + 1}</td>
//                 <td className='guest-name'>{guest.name}</td>
//                 <td className='guest-address'>
//                   {guest?.address}
//                 </td>
//                 <td className='number-guest'>{guest.guestNo}</td>
//                 <td className='category-guest'>{guest.category}</td>
//                 <td className='guest-quantity'>
//                   <input
//                     type='text'
//                     className='invite-guest-list'
//                     // FIX: Value is controlled by 'boxes' state. Show empty if quantity is 0.
//                     value={quantity > 0 ? quantity : ''}
//                     onChange={(e) => {
//                       const value = e.target.value;
//                       if (/^\d*$/.test(value)) {
//                         handleBox(value, index);
//                       }
//                     }}
//                   />
//                 </td>
//               </tr>
//             })}
//           </tbody>
//         </table>
//       </div>

//       {isDeliverycharge && <div className="shipping-info">
//         <div>Extra Shipping Charges ₹49 per box</div>
//       </div>}

//       <div className="my-address-section">
//         <div className="my-address-row">
//           <div>
//             {userData?.address ? (
//               <input type="checkbox" checked={isUserAddressChecked} onChange={(e) => handleCheckUser(e.target.checked)} />
//             ) : (
//               <input type="checkbox" disabled />
//             )}
//           </div>
//           <div>My Address</div>
//           {userData?.address && <div>{userData?.address}</div>}
//         </div>
//         <div>
//           <input
//             type='text'
//             className='my-address-text'
//             value={userBox}
//             onChange={(e) => {
//               const isNumber = e.target.value;
//               if (/^\d*$/.test(isNumber)) {
//                 handleUser(isNumber === "" ? 0 : Number(isNumber));
//               }
//             }}
//           />
//         </div>
//       </div>

//       {isDeliverycharge &&
//         <div className="shipping-info">
//           <div>Extra Shipping Charges ₹20 per box</div>
//         </div>
//       }

//       <div className="totals-bar" >
//         <span>Total Guest:{totalGuest} </span>
//         <span>Total Boxes:{totalbox} </span>
//       </div>
//       <div className="pay-button-container">
//         <button className="pay-button" onClick={handlePayment}>Pay</button>
//       </div>
//       <div className="pay-button-container">
//         Total Price:{totalPrice} /-
//       </div>
//       {openRazorpay && <Payment amount={totalPrice} guest={guest} userId={userId} />}
//     </div>
//   );
// }

import { useContext, useEffect, useState } from 'react';
import './GuestList.css';
import { Link, useLocation, useParams } from 'react-router-dom';
import axios from 'axios';
import { AuthContext } from '../context';
import { Payment } from '../payment';
import { toast } from 'react-toastify';

export const GuestList = () => {
  let { total } = useParams();
  const context = useContext(AuthContext);
  const logout = context?.logout;
  const paymentHistory = context?.paymentHistory;
  const location = useLocation();
  const invitationId = location?.state?.invitationId;
  const id = localStorage.getItem('_id');
  const totalAmountPerBox = total;
  const [userId, setUserId] = useState(id);
  const token = context?.token || localStorage.getItem("token");
  const [guestList, setGuestList] = useState([]);

  const [boxes, setBoxes] = useState([]);

  const [totalbox, setTotalBox] = useState(0);
  const [totalGuest, setTotalGuest] = useState(0);

  // FIX 2: "My Address" वाले बॉक्स के लिए शुरुआती वैल्यू "" की जगह 0 कर दी गई है।
  const [userBox, setUserBox] = useState(0);

  const [isUserAddressChecked, setIsUserAddressChecked] = useState(false);
  const [totalPrice, setTotalPrice] = useState(0);
  const [searchText, setSearchText] = useState();
  const [openRazorpay, setOpenRazorPay] = useState(false);
  const [guest, setGuest] = useState([]);
  const [userData, setUserData] = useState({});
  const [isDeliverycharge, setIsDeliverycharge] = useState();

  const getGuestList = async () => {
    await axios.get(`${process.env.REACT_APP_BASE_URL}api/user/guest-list/${userId}`, {
      headers: { Authorization: `Bearer ${token}` },
    }).then((res) => {
      setGuestList(res?.data?.guestList);
    }).catch((error) => {
      if (error?.response?.data?.Message === 'jwt expired') logout();
    });
  };

  const getUserData = async () => {
    await axios.get(`${process.env.REACT_APP_BASE_URL}api/user/data/${userId}`, {
      headers: { Authorization: `Bearer ${token}` },
    }).then((res) => {
      setUserData(res?.data?.userData);
    }).catch((error) => {
      if (error?.response?.data?.Message === 'jwt expired') logout();
    });
  };

  useEffect(() => {
    getGuestList();
    getUserData();
  }, [searchText, userId]);

  const countFun = () => {
    const itemsWithQuantity = boxes.filter(box => box.quantity > 0);

    const countBox = itemsWithQuantity.reduce(
      (total, box) => total + Number(box.quantity), 0
    );

    const countGuest = itemsWithQuantity.length;
    let total = countBox;
    let price = totalAmountPerBox * countBox;

    if (isDeliverycharge) {
      price += 49 * countBox;
    }
    if (isUserAddressChecked && userBox > 0) {
      total += Number(userBox);
      price += Number(totalAmountPerBox * userBox);
      if (isDeliverycharge) {
        price += Number(20 * userBox);
      }
    }
    setTotalBox(total);
    setTotalGuest(countGuest);
    setTotalPrice(price);
  };

  useEffect(() => {
    countFun();

    const selectedGuests = boxes
      .filter(box => box.quantity > 0)
      .map(box => {
        const guestData = guestList[box.idx];
        return {
          idx: box.idx,
          guestId: guestData._id,
          name: guestData.name,
          address: guestData.address,
          quantity: box.quantity,
          pincode: guestData?.pincode || '',
          mobile: guestData?.mobile || ''
        };
      });
    setGuest(selectedGuests);

  }, [boxes, isUserAddressChecked, userBox]);

  const handleBox = (value, index) => {
    const quantity = value === "" ? 0 : Number(value);
    const isExist = boxes.some((ele) => ele.idx === index);

    let newBoxes;
    if (isExist) {
      newBoxes = boxes.map((ele) => ele.idx === index ? { ...ele, quantity } : ele);
    } else {
      newBoxes = [...boxes, { idx: index, quantity }];
    }
    setBoxes(newBoxes);
  };

  const handleChecked = (index) => {
    const existingBox = boxes.find((ele) => ele.idx === index);
    const isCurrentlyChecked = existingBox && existingBox.quantity > 0;

    if (isCurrentlyChecked) {
      handleBox("0", index);
    } else {
      handleBox("1", index);
    }
  };

  const handleUser = (boxes) => {
    setUserBox(boxes);
  };

  const handleCheckUser = (isChecked) => {
    setIsUserAddressChecked(isChecked);
  };

  const handlePayment = () => {
    if (!paymentHistory?.length) {
      toast.error("Your data have been lose please Select One more time  !", {
        position: 'bottom-right'
      });
      return;
    }
    if (!guest?.length && (!isUserAddressChecked || !userBox > 0)) {
      toast.error("Please select at least one recipient to continue.", {
        position: 'bottom-right'
      });
      return;
    }

    setOpenRazorPay(false);
    setTimeout(() => {
      setOpenRazorPay(true);
    }, 50);
  };

  return (
    <div className="guest-list-container">
      <div className="guest-list-header"></div>
      <div className="table-wrapper">
        <table>
          <thead>
            <tr>
              <th className='guest-hash'>'#'</th>
              <th className='guest-no'>No.</th>
              <th className='guest-name'>NAME</th>
              <th className='guest-address'>ADDRESS</th>
              <th className='number-guest'>GUEST NUMBER</th>
              <th className='category-guest'>CATEGORIES</th>
              <th className='guest-quantity'>Boxes quantity</th>
            </tr>
          </thead>
          <tbody>
            {guestList?.map((guest, index) => {
              if (!guest?.address) return null;

              const currentBox = boxes.find((ele) => ele.idx === index);
              const quantity = currentBox?.quantity || 0;

              return <tr key={guest._id || index}>
                <td className='guest-hash'>
                  {guest.address ? (
                    <input
                      type="checkbox"
                      checked={quantity > 0}
                      onChange={() => { handleChecked(index) }}
                    />
                  ) : (
                    <input type="checkbox" disabled />
                  )}
                </td>
                <td className='guest-no'>{index + 1}</td>
                <td className='guest-name'>{guest.name}</td>
                <td className='guest-address'>
                  {guest?.address}
                </td>
                <td className='number-guest'>{guest.guestNo}</td>
                <td className='category-guest'>{guest.category}</td>
                <td className='guest-quantity'>
                  <input
                    type='text'
                    className='invite-guest-list'
                    // FIX 1: वैल्यू को सीधे `quantity` पर सेट किया गया है ताकि 0 दिखे।
                    value={quantity}
                    onChange={(e) => {
                      const value = e.target.value;
                      if (/^\d*$/.test(value)) {
                        handleBox(value, index);
                      }
                    }}
                  />
                </td>
              </tr>
            })}
          </tbody>
        </table>
      </div>

      {isDeliverycharge && <div className="shipping-info">
        <div>Extra Shipping Charges ₹49 per box</div>
      </div>}

      <div className="my-address-section">
        <div className="my-address-row">
          <div>
            {userData?.address ? (
              <input type="checkbox" checked={isUserAddressChecked} onChange={(e) => handleCheckUser(e.target.checked)} />
            ) : (
              <input type="checkbox" disabled />
            )}
          </div>
          <div>My Address</div>
          {userData?.address && <div>{userData?.address}</div>}
        </div>
        <div>
          <input
            type='text'
            className='my-address-text'
            value={userBox}
            onChange={(e) => {
              const isNumber = e.target.value;
              if (/^\d*$/.test(isNumber)) {
                handleUser(isNumber === "" ? 0 : Number(isNumber));
              }
            }}
          />
        </div>
      </div>

      {isDeliverycharge &&
        <div className="shipping-info">
          <div>Extra Shipping Charges ₹20 per box</div>
        </div>
      }

      <div className="totals-bar" >
        <span>Total Guest:{totalGuest} </span>
        <span>Total Boxes:{totalbox} </span>
      </div>
      <div className="pay-button-container">
        <button className="pay-button" onClick={handlePayment}>Pay</button>
      </div>
      <div className="pay-button-container">
        Total Price:{totalPrice} /-
      </div>
      {openRazorpay && <Payment amount={totalPrice} guest={guest} userId={userId} />}
    </div>
  );
}